import RichContent from '../common/RichContent';

function CourseDetailsSection({ content }) {
  if (!content) return null;

  return (
    <section>
      <h2 className="text-xl font-bold text-[#146599]">Course Details</h2>
      <div className="mt-4">
        <RichContent content={content} />
      </div>
    </section>
  );
}

export default CourseDetailsSection;
